import React from 'react';
import { connect } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Spin from '../../../../components/loading';
import * as reservationsActions from '../../../../redux/reservations/actions';
import { formatter, enumHelper } from '../../../../utils';
import ENUMS from '../../../../enums';
import '../reservations.scss';

class RseeReservationFactor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: [],
      num: '',
      subTotalPrice: 0,
      invoiceAdditionsAmount: null,
      invoiceDeductionsAmount: null,
      multipleSelectedValue: '',
      errorFlag: false,
      invoiceAdditions: [],
      invoiceDeductions: [],
      totalDiscountPercent: 0,
      discountCodeAmount: 0,
      discountCodeType: ENUMS.DISCOUNT_CODES_TYPES.values.PERCENT,
      errorText: '',
      loaded: false,
      isSuspended: false,
      reserveCreatedFullName: '',
      reservePersons: null,
      reserveStatus: '',
      reserveDate: '',
      reserveStartAt: '',
      reserveEndAt: '',
      menuItems: [],
      invoiceItems: [],
      respondedAt: '',
      reserveTrackingNumber: '',
      reserveMeal: '',
      reserveType: '',
      respondedFullName: '',
      reservedTables: [],
      quantity: '',
      printerTarget: '',
      reserveBaseCost: 0,
      unitPrice: 0,
      totalPrice: 0,
    };
  }

  quantityInputRef = React.createRef();
  formRefrence = React.createRef();
  failedRefrence = React.createRef();
  errorRefrence = React.createRef();
  insertedRefrence = React.createRef();
  finalInsertedRefrence = React.createRef();

  componentDidMount() {
    this.props.fetchReservationInvoiceDetails(this.props.reservationId);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.loaded == false &&
      Object.entries(this.props.reservationInvoiceDetails).length &&
      this.props.cafeName
    ) {
      let {
        currency,
        invoiceItems,
        reserveCreatedFullName,
        reservePersons,
        totalDiscountPercent,
        discountCodeAmount,
        discountCodeType,
        reserveStatus,
        reserveDate,
        invoiceAdditionsAmount,
        invoiceDeductionsAmount,
        reserveStartAt,
        invoiceAdditions,
        invoiceDeductions,
        reserveEndAt,
        respondedAt,
        isSuspended,
        reserveBaseCost,
        menuItems,
        subTotalPrice,
        totalPrice,
        reserveTrackingNumber,
        reservedTables,
        reserveMeal,
      } = this.props.reservationInvoiceDetails;

      // let mappedMenuItems = [];
      // if (invoiceItems && invoiceItems.length) {
      //   mappedMenuItems = invoiceItems.map(x => ({
      //     id: x.menuItemId,
      //     value: x.menuItemId,
      //     price: x.price,
      //     quantity: x.quantity,
      //     totalPrice: x.totalPrice,
      //     title: !this.props.cafeName ? (!!this.props.menuItemsList && this.props.menuItemsList.length &&
      //       this.props.menuItemsList.some(item => item.id == x.menuItemId) &&
      //       this.props.menuItemsList.filter(item => item.id == x.menuItemId)[0].title)
      //       : x.title,
      //     label: !this.props.cafeName ? !!this.props.menuItemsList && this.props.menuItemsList.length &&
      //       this.props.menuItemsList.some(item => item.id == x.menuItemId) &&
      //       this.props.menuItemsList.filter(item => item.id == x.menuItemId)[0].title
      //       : x.title
      //   }));
      // }

      this.setState(
        {
          currency,
          reserveBaseCost,
          reserveCreatedFullName,
          invoiceAdditions,
          invoiceDeductions,
          reservePersons,
          reserveStatus,
          invoiceItems,
          reserveDate,
          reserveStartAt,
          isSuspended,
          totalDiscountPercent,
          invoiceAdditionsAmount,
          invoiceDeductionsAmount,
          discountCodeAmount,
          discountCodeType,
          reserveEndAt,
          menuItems,
          respondedAt,
          subTotalPrice,
          totalPrice,
          reserveTrackingNumber,
          reserveMeal,
          reservedTables,
          loaded: true,
        },
        () => {
          Array.from(this.formRefrence.current).forEach(element => {
            if (element.name || element.id) {
              element.value = this.state[element.name];
            }
          });
        },
      );
    }
  }

  render() {
    let { errorFlag, errorText } = this.state;

    let { loading, error, message, failed, reservationInvoiceDetails } = this.props;

    return (
      <>
        <Modal id="financial-transaction-modal" size="xl" isOpen={this.props.isOpen}>
          <Spin spinning={loading}>
            <ModalHeader>
              <div className="row">
                <div className="col-12 text-left">
                  <a
                    href="#"
                    className=""
                    onClick={event => {
                      event.preventDefault();
                      this.props.closeModal();
                    }}
                  >
                    <i className="fas fa-times"></i>
                  </a>
                </div>
                <h3 className="col-12 text-center align-middle py-3">{`${locales('titles.cafe')} ${
                  this.props.reserveCafeName
                }`}</h3>
                <h6 className="col-12 d-flex justify-content-end align-items-center">
                  <div className="col-10 d-flex justify-content-end align-items-center">
                    <div>{locales('titles.reservationDate')} :</div>
                    <div namw="reserveDate">{reservationInvoiceDetails.reserveDate}</div>
                  </div>
                  <div className="col-3 d-flex justify-content-end align-items-center">
                    <div>{locales('titles.reservationHour')} :</div>
                    <div
                      name="reserveStartAt">{`${reservationInvoiceDetails.reserveStartAt && reservationInvoiceDetails.reserveStartAt.split(' ')[1]} - ${
                      reservationInvoiceDetails.reserveEndAt && reservationInvoiceDetails.reserveEndAt.split(' ')[1]
                    }`}</div>
                  </div>
                </h6>
                <div className="col-12 d-flex justify-content-start align-items-center font-small py-2">
                  <div className="col-3 d-flex justify-content-start align-items-center">
                    <div>{locales('titles.customerFullName')} :</div>
                    <div name="reserveCreatedFullName">{reservationInvoiceDetails.customerFullName}</div>
                  </div>
                  <div className="col-2 d-flex justify-content-start align-items-center">
                    <div>{locales('tables.peopleCount')} :</div>
                    <div name="reservePersons">{reservationInvoiceDetails.reservePersons}</div>
                  </div>
                  <div className="col-2 d-flex justify-content-start align-items-center">
                    <div>{locales('tables.tableNumber')} :</div>
                    <div name="reservedTables">
                      {reservationInvoiceDetails.reservedTables &&
                      reservationInvoiceDetails.reservedTables.length &&
                      reservationInvoiceDetails.reservedTables.map(
                        (ele, index, self) => ` ${ele.num} ${index < self.length - 1 ? '،' : ''}`,
                      )}
                    </div>
                  </div>
                  <div className="col-2 d-flex justify-content-start align-items-center">
                    <div>{locales('tables.mealPortions')} :</div>
                    <div name="mealPortions">
                      {(reservationInvoiceDetails.reserveMeal &&
                        reservationInvoiceDetails.reserveMeal.length &&
                        enumHelper.convertEnumValueToTitle(ENUMS.MEAL_PORTIONS.list, reservationInvoiceDetails.reserveMeal)) ||
                      '---'}
                    </div>
                  </div>
                  <div className="col-3 d-flex justify-content-end align-items-center">
                    <div>{locales('fields.trackingNumber')} :</div>
                    <div name="reserveTrackingNumber"
                         className='direction-ltr'>{reservationInvoiceDetails.reserveTrackingNumber}</div>
                  </div>
                </div>
              </div>
            </ModalHeader>
            <article ref={this.formRefrence}>
              <ModalBody>
                {errorFlag && <div className="alert alert-danger">{errorText}</div>}

                {error && (
                  <div ref={this.errorRefrence} id="error" className="alert alert-danger">
                    {locales('messages.server.error')}
                  </div>
                )}
                {failed && (
                  <div ref={this.failedRefrence} id="failed" className="alert alert-danger">
                    {message}
                  </div>
                )}

                <div>
                  {reservationInvoiceDetails.menuItems && reservationInvoiceDetails.menuItems.length ? (
                    <div className="col-12 d-flex my-3 justify-content-between">
                      <div className="col-12">
                        <h5 className="text-center align-middle border rounded py-3">
                          {locales('titles.userSelectedItems')}
                        </h5>
                        <table className="table table-bordered table-hover table-light table-striped">
                          <thead>
                          <tr>
                            <th className="text-center align-middle">{locales('tables.row')}</th>
                            <th className="text-center align-middle">{locales('tables.title')}</th>
                            <th className="text-center align-middle">{locales('tables.count')}</th>
                            <th className="text-center align-middle">{locales('tables.price')}</th>
                          </tr>
                          </thead>
                          <tbody>
                          {reservationInvoiceDetails.menuItems.map((item, index) => (
                            <tr key={item.id}>
                              <td className="text-center">{index + 1}</td>
                              <td className="text-center">{item.title}</td>
                              <td className="text-center">{item.count}</td>
                              <td className="text-center">{formatter.numberWithCommas(item.price)}</td>
                            </tr>
                          ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ) : (
                    ''
                  )}

                  <div className="col-12 d-flex my-3 justify-content-between">
                    <div className="col-12">
                      <h5 className="text-center align-middle border rounded py-3">
                        {locales('titles.insertOrder')}
                      </h5>
                      <table className="table table-hover table-bordered table-striped" width="100">
                        <thead>
                        <tr>
                          <th className="text-center align-middle">{locales('tables.row')}</th>
                          <th className="text-center align-middle">{locales('tables.title')}</th>
                          <th className="text-center align-middle w-50">{locales('tables.count')}</th>
                          <th className="text-center align-middle">{locales('tables.unitPrice')}</th>
                          <th className="text-center align-middle">{locales('tables.totalPrice')}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {reservationInvoiceDetails.invoiceItems && reservationInvoiceDetails.invoiceItems.map((invoiceItem, index) => (
                          <tr key={index}>
                            <td className="text-center align-middle">{index + 1}</td>
                            <td className="text-center align-middle">{invoiceItem.title}</td>
                            <td className="text-center align-middle">{invoiceItem.quantity}</td>
                            <td className="text-center align-middle">
                              {formatter.numberWithCommas(invoiceItem.price)}
                            </td>
                            <td className="text-center align-middle">
                              {formatter.numberWithCommas(invoiceItem.quantity * invoiceItem.price || 0)}
                            </td>
                          </tr>
                        ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="col-12 d-flex my-3 justify-content-between">
                    {reservationInvoiceDetails.invoiceAdditions && reservationInvoiceDetails.invoiceAdditions.length ? (
                      <div className="col-6">
                        <h5 className="text-center">{locales('titles.additions')}</h5>
                        <table className="table table-hover table-striped table-bordered table-light">
                          <thead>
                          <tr>
                            <th className="text-center">{locales('tables.row')}</th>
                            <th className="text-center">{locales('tables.title')}</th>
                            <th className="text-center">{locales('messages.quantity')}</th>
                            <th className="text-center">{locales('labels.withPercentage')}</th>
                          </tr>
                          </thead>
                          <tbody>
                          {reservationInvoiceDetails.invoiceAdditions.map((item, index) => (
                            <tr key={item.id}>
                              <td className="text-center">{index + 1}</td>
                              <td className="text-center">{item.title}</td>
                              <td className="text-center">{item.value}</td>
                              <td className="text-center">
                                <i
                                  className={
                                    item.isPercent
                                      ? 'fal fa-vote-yea text-success'
                                      : 'fal fa-vote-nay text-danger'
                                  }
                                />
                              </td>
                            </tr>
                          ))}
                          </tbody>
                        </table>
                      </div>
                    ) : null}
                    {/* {invoiceDeductions && invoiceDeductions.length ? (
                      <div className="col-6">
                        <h5 className="text-center">{locales('titles.deductions')}</h5>
                        <table className="table table-hover table-striped table-bordered table-light">
                          <thead>
                            <tr>
                              <th className="text-center">{locales('tables.row')}</th>
                              <th className="text-center">{locales('tables.title')}</th>
                              <th className="text-center">{locales('messages.quantity')}</th>
                              <th className="text-center">{locales('labels.withPercentage')}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {invoiceDeductions.map((item, index) => (
                              <tr key={item.id}>
                                <td className="text-center">{index + 1}</td>
                                <td className="text-center">{item.title}</td>
                                <td className="text-center">{item.value}</td>
                                <td className="text-center">
                                  <i
                                    className={
                                      item.isPercent
                                        ? 'fal fa-vote-yea text-success'
                                        : 'fal fa-vote-nay text-danger'
                                    }
                                  />
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    ) : null} */}
                  </div>

                  <div className="col-12 border-top py-5">
                    {reservationInvoiceDetails.invoiceAdditionsAmount ? (
                      <div className="col-3 d-flex justify-content-center align-items-center border rounded p-3 my-2">
                        <div className="col-5">{locales('titles.additionals')} :</div>
                        <div
                          className="col-7">{formatter.numberWithCommas(reservationInvoiceDetails.invoiceAdditionsAmount)}</div>
                      </div>
                    ) : null}

                    {/* {invoiceDeductionsAmount ? (
                      <div className="col-3 d-flex justify-content-center align-items-center border rounded p-3 my-2">
                        <div className="col-5">{locales('titles.deductions')} : </div>
                        <div className="col-7">{formatter.numberWithCommas(invoiceDeductionsAmount)}</div>
                      </div>
                    ) : null} */}

                    {reservationInvoiceDetails.reserveBaseCost ? (
                      <div className="col-3 d-flex justify-content-center align-items-center border rounded p-3 my-2">
                        <div className="col-6">{locales('tables.prePaid')} :</div>
                        <div className="col-6" name="reserveBaseCost">
                          {formatter.numberWithCommas(reservationInvoiceDetails.reserveBaseCost)}
                        </div>
                      </div>
                    ) : null}

                    {reservationInvoiceDetails.totalDiscountPercent ? (
                      <div className="col-3 d-flex justify-content-center align-items-center border rounded p-3 my-2">
                        <div className="col-5">{locales('tables.discount')} :</div>
                        <div
                          className="col-7">{formatter.numberWithCommas(reservationInvoiceDetails.totalDiscountPercent)}</div>
                      </div>
                    ) : null}

                    {reservationInvoiceDetails.discountCodeAmount ? (
                      <div className="col-3 d-flex justify-content-center align-items-center border rounded p-3 my-2">
                        <div className="col-6">{locales('tables.discountWithCode')} :</div>
                        <div className="col-6">
                          {formatter.numberWithCommas(reservationInvoiceDetails.discountCodeAmount)}{' '}
                          {reservationInvoiceDetails.discountCodeType == ENUMS.DISCOUNT_CODES_TYPES.values.PERCENT
                            ? locales('labels.percent')
                            : locales('tables.toman')}
                        </div>
                      </div>
                    ) : null}

                    {reservationInvoiceDetails.subTotalPrice ? (
                      <div className="col-3 d-flex justify-content-center align-items-center border rounded p-3 my-2">
                        <div className="col-5">{locales('tables.totalPrice')} :</div>
                        <div
                          className="col-7">{formatter.numberWithCommas(reservationInvoiceDetails.subTotalPrice)}</div>
                      </div>
                    ) : null}

                    {reservationInvoiceDetails.totalPrice ? (
                      <div className="col-12 d-flex justify-content-end align-items-center p-3 my-2">
                        <div
                          className="col-5 d-flex text-dark justify-content-start align-items-center border rounded py-4 font-large font-weight-bold">
                          <div className="col-6">{locales('tables.payablePrice')} :</div>
                          <div
                            className="col-6">{formatter.numberWithCommas(reservationInvoiceDetails.toBePaidToCafePrice)}</div>
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
              </ModalBody>
              <ModalFooter>
                <div className="d-flex col-12 justify-content-end align-items-center">
                  <div className="col-4 d-flex justify-content-end align-items-center">
                    <button
                      className="btn btn-outline-secondary mx-1"
                      onClick={() => this.props.closeModal()}
                    >
                      {locales('labels.close.modal')}
                    </button>
                  </div>
                </div>
              </ModalFooter>
            </article>
          </Spin>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    reservationInvoiceDetails: state.reservationsReducer.reservationInvoiceDetails,
    loading: state.reservationsReducer.reservationInvoiceDetailsLoading,
    message: state.reservationsReducer.reservationInvoiceDetailsMessage,
    failed: state.reservationsReducer.reservationInvoiceDetailsFailed,
    error: state.reservationsReducer.reservationInvoiceDetailsError,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    fetchReservationInvoiceDetails: id => dispatch(reservationsActions.fetchReservationInvoiceDetails(id)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RseeReservationFactor);
